import { Region } from './region'
import { User } from './user'

export enum ApplicationStatus {
  INITED = 'inited',
  CONSIDERATION = 'consideration',
  ON_FIX = 'on_fix',
  SUCCESS = 'success',
  FAIL = 'fail',
  DECLINED = 'declined',
  ERROR = 'error',
}

export type ApplicationAttachedCard = {
  application: number
  id: number
  is_identified: boolean
  number: string
  type: string
}

export interface MJuniorChild {
  id: number
  phone_number: string
  name: string
  surname: string
  inn: string
  birthdate: string
  gender: string
  serial_and_number_certificate: string
  child_certificate: string
  child_certificate_back?: string
  parent: number
}

export interface Application {
  id: number
  name: string
  surname: string
  middle_name: string
  birthdate: string
  anketa_photo: string
  client_photo: string
  anketa_file: string | null
  inn: string
  document_number: string
  issuing_authority: string
  expire_date: string
  is_identified: boolean
  pan: string
  grs_photo: string
  live_photo: string
  ui_photo: string
  status: ApplicationStatus
  consultant?: User
  created_at: string
  attached_cards: ApplicationAttachedCard[]
  card: ApplicationAttachedCard
  passport_back_photo: string
  passport_front_photo: string
  tyndyk_passport?: Array<{
    file: string
    id: number
  }>
  children?: MJuniorChild
  controller_comment: string | null
  region: Region
  m_junior: boolean
}

export interface ApplicationStatusHistory {
  id: number
  changed_at: string
  changed_by: string
  comment: string
  new_status: string
  new_status_display: string
  old_status: string
  old_status_display: string
}
